export default __webpack_public_path__ + "static/media/pink.c4fc8bfb.jpg";